<script lang="ts">
import { useFilterStub } from './filter-stub';
import { LocalFilterModel } from './FilterSelectMultiple.vue';
</script>

<script setup lang="ts" generic="T">
defineExpose(
  useFilterStub<T, LocalFilterModel<T>>(
    { values: [] },
    ({ values }) => values.length > 0,
    ({ values }, value) => values.includes(value)
  )
);
</script>

<!-- eslint-disable-next-line vue/valid-template-root -->
<template></template>
